<a class="mini-cart-trash" title="Delete">
  <fa-icon icon="trash-alt" (click)="modalDialog.show()" />
</a>
<ish-modal-dialog #modalDialog [options]="options()" (shown)="shown()" (closed)="closed()" (confirmed)="confirmed()">
  @if (lazyContent()) { @if (shown$ | async) {
  <div>
    <ng-container *ngTemplateOutlet="lazyContent().templateRef" />
  </div>
  } } @else {
  <ng-content />
  }
</ish-modal-dialog>
